
import ieDetect from '../utils/ie-detect.js'
import { _query } from '../utils/query.js'
import ScrollMagic from 'scrollmagic'

// window.ScrollMagic = ScrollMagic
const controller = new ScrollMagic.Controller()
// let panelBottomShouldBeFixed
// let rightColumnHeight

export function checkoutScene () {
  const isIe = ieDetect().name === 'Explorer'
  if (!isMobile && !isIe) {
    new ScrollMagic.Scene({
      triggerElement: '.trigger1',
      duration: 2000,
      offset: 0,
      triggerHook: 'onLeave'
      // scrollOffset: 450
      // reverse: false
    })
      // .setPin('#fast-payment-check-out-bar')
      .setClassToggle('#fast-payment-check-out-bar', 'sticky')
      .addTo(controller)

    const windowHeight = window.innerHeight
    const panel = _query('.fast-payment-order-inner')
    const panelHeight = panel.getBoundingClientRect().height
    // const panelHeight = $('.fast-payment-order-inner').outerHeight()
    // console.debug(
    //   `${panelHeight}, ${windowHeight}, ${panelHeight - windowHeight}`
    // )

    // const adjustHeader = $('#mobile-header-wrapper').outerHeight()

    // to fix the firefox scroll bug on NL site:
    // const toggleClass =
    //   panelHeight - windowHeight >= -adjustHeader ? 'no-sticky' : 'sticky'
    const toggleClass = checkoutPanelHeightDetect()
      ? 'sticky-top'
      : 'sticky-bottom'

    const myScene = new ScrollMagic.Scene({
      triggerElement: '.trigger1',
      duration: 2000,
      triggerHook: 'onLeave'
    })
      .on('enter', event => {
        // panel.classList.add(toggleClass)
        panel.setAttribute('class', `fast-payment-order-inner ${toggleClass}`)
        console.debug('on enter')
      })
      .on('start', event => {
        console.debug('on start')
      })
      .on('leave', event => {
        // panel.classList.remove(toggleClass)
        panel.setAttribute('class', `fast-payment-order-inner`)
        console.debug('on leave')
      })
      // .setClassToggle('.fast-payment-order-inner', toggleClass)
      // .addIndicators({ name: 'loop' })
      .addTo(controller)

    window.myScene = myScene

  }
}

function checkoutPanelHeightDetect () {
  const windowHeight = window.innerHeight
  const panel = _query('.fast-payment-order-inner')
  // const header = _query('#mobile-header-wrapper')
  const panelHeight = panel.getBoundingClientRect().height
  // const rightColumnHeight = panelHeight + header.getBoundingClientRect().height
  // console.debug(
  //   `checkoutPanelHeightDetect : ${rightColumnHeight}, ${windowHeight}, ${rightColumnHeight - windowHeight}`
  // )
  if (windowHeight > panelHeight) {
    return true
  } else {
    return false
  }
}

window.checkoutScene = checkoutScene
window.controller = controller

// export function cartScene() {
//   addBlankDiv('mobile-width-detect')
//   const isMobileWidth = $('.mobile-width-detect').css('position') === 'relative'
//   // var gapHeight = $('#review-cart-submit-mobile-placeholder').outerHeight()
//   if (isMobileWidth) {
//     new ScrollMagic.Scene({
//       triggerElement: '.trigger-cart-line',
//       duration: 2000,
//       offset: 0,
//       triggerHook: 'onLeave'
//     })
//       .setClassToggle('#review-cart-submit-mobile-placeholder', 'sticky')
//
//       .on('enter', function(event) {
//         $('#review-cart-submit-fixed-placeholder').addClass('sticky')
//         // console.log('on enter')
//       })
//       .on('start', function(event) {
//         // console.log('on start')
//       })
//       .on('leave', function(event) {
//         $('#review-cart-submit-fixed-placeholder').removeClass('sticky')
//         // console.log('on leave')
//       })
//       // .setTween(trailer, {scale:scaleVar, ease: Circ.easeIn})
//       // .addIndicators({name: 'loop'})
//       .addTo(controller)
//   }
// }
